<template>
    <div>
        <v-card>
            <v-card-title style="background-color: #e6e6e6;" class="justify-center">
                <v-icon left>apartment</v-icon>
                Lista de Escolas
            </v-card-title>

            <v-card-text>

                <v-row class="mt-5">
                    <v-text-field label="Pesquisar" v-model="pesquisa" class="ml-5 mr-5"/>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="novaEscola" v-on="on" dark fab color="blue" class="mr-5">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </template>
                        <span>Cadastrar</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn disabled @click="novaEscola" v-on="on" fab color="grey" class="mr-5">
                                <v-icon>save_alt</v-icon>
                            </v-btn>
                        </template>
                        <span>Cadastrar</span>
                    </v-tooltip>
                </v-row>

                <v-data-table
                        no-results-text="Nenhuma escola encontrada!"
                        no-data-text="Nenhuma escola cadastrada!"
                        loading-text="Carregando..."
                        :footer-props="footerProps"
                        :headers="headers"
                        :items="escolas"
                        :search="pesquisa"
                        :loading="carregandoEscolas"
                >

                    <template v-slot:item.action="{ item }">

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon color="blue" @click="editarEscola(item)"> edit</v-icon>
                                </v-btn>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon color="red" @click="deletarEscola(item)">delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Deletar</span>
                        </v-tooltip>

                    </template>

                </v-data-table>

            </v-card-text>
        </v-card>

        <v-dialog v-model="registerDialog" width="500">
            <v-card>
                <v-card-title v-if="editando" style="background-color: #e6e6e6;" class="justify-center">
                    <v-icon left>apartment</v-icon>
                    Editando Escola
                </v-card-title>

                <v-card-title v-else style="background-color: #e6e6e6;" class="justify-center">
                    <v-icon left>apartment</v-icon>
                    Nova Escola
                </v-card-title>

                <v-card-text>
                    <v-text-field label="Nome" v-model="escola.nome" class="ml-5 mr-5 mt-5"/>
                </v-card-text>

                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn :loading="salvando" color="grey" dark
                           @click="registerDialog = false">
                        CANCELAR
                    </v-btn>
                    <v-btn :loading="salvando" color="success" :disabled="!escola.nome"
                           @click="editando ? atualizarEscola() : salvarEscola()">
                        SALVAR
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <!-- SNACKBAR DIALOG -->
        <v-snackbar
                absolute
                v-model="snackbar.active"
                :color="snackbar.color"
                :top="true"
        >
            {{snackbar.message}}
            <v-btn dark text @click="snackbar.active = false">
                Fechar
            </v-btn>
        </v-snackbar>
        <!-- SNACKBAR DIALOG -->

        <!-- CONFIRM DIALOG -->
        <v-dialog v-model="confirmDialog" min-width="290" max-width="500" persistent>
            <v-card>
                <v-card-title class="headline">{{menssage}}</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn :disabled="confirmando" color="error" text @click="confirmDialog=false">CANCELAR</v-btn>
                    <v-btn :loading="confirmando" color="green darken-1" text @click="confirmFunction">ACEITAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- CONFIRM DIALOG -->

    </div>
</template>

<script>

    import EscolaService from "../../service/EscolaService";

    export default {
        data() {
            return {
                footerProps: {
                    itemsPerPageText: "Itens por página:",
                    itemsPerPageOptions: [10, 20, 50]
                },
                headers: [
                    {
                      text: "id",
                      value: "id",
                      align: "center"
                    },
                    {
                        text: "Nome",
                        value: "nome",
                        align: "center"
                    },
                    {
                        text: "Cidade",
                        value: "cidade",
                        align: "center"
                    },
                    {
                        text: "Ação",
                        value: "action",
                        align: "center",
                        sortable: false
                    },
                ],
                escolas: [],
                pesquisa: "",
                carregandoEscolas: false,

                snackbar: {
                    message: "",
                    color: "",
                    active: ""
                },

                confirmDialog: false,
                menssage: "",
                confirmando: false,

                escolaParaDeletar: 0,
                confirmFunction: null,

                registerDialog: false,
                salvando: false,
                escola: {
                    id: null,
                    nome: null,
                    owner: null
                },
                editando: false
            }
        },
        methods: {

            novaEscola() {

                this.limparModal();
                this.editando = false;

                this.registerDialog = true;
            },

            editarEscola(escola) {

                this.limparModal();
                this.editando = true;

                this.escola.nome = escola.nome;
                this.escola.id = escola.id;

                this.registerDialog = true;
            },

            deletarEscola(item) {
                this.menssage = `Deseja deletar a escola ${item.nome}:`;
                this.confirmDialog = true;
                this.confirmFunction = this.confirmarDeletarEscola;
                this.escolaParaDeletar = item.id;
            },

            confirmarDeletarEscola() {
                this.confirmando = true;
                EscolaService.deletarEscola(this.escolaParaDeletar)
                    .then(() => {
                        this.snackbar.color = "green";
                        this.snackbar.message = "Escola deletada com sucesso!";
                        this.snackbar.active = true;
                        this.buscarListaDeEscolas();
                    })
                    .catch(() => {
                        this.snackbar.color = "red";
                        this.snackbar.message = "Erro ao deletar escola!";
                        this.snackbar.active = true;
                    })
                    .finally(() => {
                        this.confirmDialog = false;
                        this.confirmando = false;
                    })
            },

            salvarEscola() {

                this.salvando = true;
                this.escola.id = null;

                EscolaService.salvarEscola(this.escola)
                    .then(() => {
                        this.snackbar.color = "green";
                        this.snackbar.message = "Escola salva com sucesso!";
                        this.snackbar.active = true;
                        this.buscarListaDeEscolas();
                    })
                    .catch(() => {
                        this.snackbar.color = "red";
                        this.snackbar.message = "Erro ao salva escola!";
                        this.snackbar.active = true;
                    })
                    .finally(() => {
                        this.salvando = false;
                        this.limparModal();
                    })

            },

            atualizarEscola() {
                this.salvando = true;

                EscolaService.atualizarEscola(this.escola)
                    .then(() => {
                        this.snackbar.color = "green";
                        this.snackbar.message = "Escola atualizada com sucesso!";
                        this.snackbar.active = true;
                        this.buscarListaDeEscolas();
                    })
                    .catch(() => {
                        this.snackbar.color = "red";
                        this.snackbar.message = "Erro ao salva escola!";
                        this.snackbar.active = true;
                    })
                    .finally(() => {
                        this.salvando = false;
                        this.limparModal();
                    })
            },

            buscarListaDeEscolas() {

                this.carregandoEscolas = true;
                EscolaService.buscarListaDeEscolas()
                    .then(({data}) => {
                        this.escolas = data;
                    })
                    .catch(() => {
                        this.snackbar.color = "red";
                        this.snackbar.message = "Erro ao carregar Escolas!";
                        this.snackbar.active = true;
                    })
                    .finally(() => {
                        this.carregandoEscolas = false;
                    })
            },

            limparModal() {

                this.registerDialog = false;
                this.escola.nome = null;
                this.escola.id = null;
                this.escola.owner = null;
            }
        },
        created() {
            this.buscarListaDeEscolas();
        }
    }
</script>

<style scoped>

</style>
